<template>
    <div role="tabcard" class="tab-pane" id="draft-change-orders">
        <draft-change-orders-list :role="role" :user="user" :project="project"></draft-change-orders-list>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user', 'project'],

        created: function() {
        },

        mounted: function() {
        },

        data: function() {
            return {
            };
        },

        watch: {
        },

        computed: {
            
        },

        methods: {
        }
    }
</script>
